import { ReelsEngineSlotSoundController, SlotSoundType } from '@cgs/machines';
import { SoundState } from '@cgs/wge';

export class CorsicaBaseSlotSoundController extends ReelsEngineSlotSoundController {
  playBackgroundSound(): void {
    const configEntry = this._configEntries.find(
      (e) => e.soundType == SlotSoundType.Background && e.soundState == SoundState.Playing
    );

    if (configEntry) {
      this.sendBackGroundSoundEvent(configEntry.trigger);
    }
  }
}
